module.exports = __webpack_public_path__ + "static/media/19.de22b855.jpeg";